import React from "react";
import RMDashboard from "../../components/RMDashboard/RMDashboard";
const RMDashboardContainers = () => {
  return <RMDashboard />;
};

export default RMDashboardContainers;
